
import React, { useEffect, useState } from 'react';
// @ts-ignore
import confetti from 'canvas-confetti';

declare global {
  interface Window {
    adsbygoogle: unknown[];
  }
}

interface Props {
  onContinue: () => void;
}

const AdGateModal: React.FC<Props> = ({ onContinue }) => {
  const [countdown, setCountdown] = useState(5);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          confetti({
            particleCount: 80,
            spread: 60,
            origin: { y: 0.7 },
            colors: ['#6366f1', '#8b5cf6', '#ffffff'],
            disableForReducedMotion: true,
          });
          setReady(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (!import.meta.env.DEV) {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (_) {
        // AdSense script not loaded yet
      }
    }
  }, []);

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-[60] p-4 animate-fade-in">
      <div className="bg-base-100 dark:bg-dark-200 rounded-2xl shadow-2xl border border-base-300 dark:border-dark-300 max-w-sm w-full p-6 flex flex-col items-center gap-5">

        <div className="text-center">
          <p className="text-xs font-semibold uppercase tracking-widest text-base-content/40 dark:text-dark-content/40 mb-1">
            Sponsored
          </p>
          <h3 className="text-lg font-bold text-base-content dark:text-dark-content">
            Your transcript is ready!
          </h3>
        </div>

        {import.meta.env.DEV ? (
          <div className="w-[300px] h-[250px] bg-base-200 dark:bg-dark-300 flex flex-col items-center justify-center rounded-xl border-2 border-dashed border-base-300 dark:border-dark-300">
            <span className="text-base-content/40 dark:text-dark-content/40 text-sm font-medium">Ad Placeholder</span>
            <span className="text-base-content/30 dark:text-dark-content/30 text-xs mt-1">300 x 250 — dev mode</span>
          </div>
        ) : (
          <ins
            className="adsbygoogle"
            style={{ display: 'inline-block', width: '300px', height: '250px' }}
            data-ad-client="ca-pub-PLACEHOLDER"
            data-ad-slot="PLACEHOLDER"
          />
        )}

        <button
          onClick={ready ? onContinue : undefined}
          disabled={!ready}
          className={`w-full py-3 px-5 rounded-xl text-sm font-bold transition-all duration-300 ${
            ready
              ? 'bg-brand-primary text-white hover:bg-brand-dark hover:scale-105 active:scale-95 shadow-lg shadow-brand-primary/20 cursor-pointer'
              : 'bg-base-200 dark:bg-dark-300 text-base-content/50 dark:text-dark-content/50 cursor-not-allowed'
          }`}
        >
          {ready
            ? 'Access Transcript →'
            : `Your transcript will be ready in ${countdown}...`}
        </button>
      </div>
    </div>
  );
};

export default AdGateModal;
